import { useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, MessageCircle, KanbanSquare, Camera, FolderOpen } from "lucide-react";
import { useChatUnread } from "@/lib/chat";

const MOBILE_DESTINATIONS = [
  { key: "dashboard", label: "Start", icon: LayoutDashboard, color: "#007AFF", to: "/" },
  { key: "chat", label: "Chat", icon: MessageCircle, color: "#34C759", to: "/chat" },
  { key: "pipeline", label: "Pipeline", icon: KanbanSquare, color: "#AF52DE", to: "/companion?tab=pipeline" },
  { key: "capture", label: "Vor Ort", icon: Camera, color: "#5AC8FA", to: "/companion?tab=capture" },
  { key: "files", label: "Dateien", icon: FolderOpen, color: "#FFCC00", to: "/companion?tab=files" },
];

function isDestinationActive(item, pathname, search) {
  if (item.key === "dashboard") return pathname === "/";
  if (item.key === "chat") return pathname === "/chat";
  if (pathname !== "/companion") return item.key === "files" && pathname === "/dateien";
  const tab = new URLSearchParams(search).get("tab") || "capture";
  return tab === item.key;
}

export function MobileDock() {
  const location = useLocation();
  const navigate = useNavigate();
  const chatUnread = useChatUnread(location.pathname === "/chat");

  return (
    <nav
      data-testid="mobile-app-dock"
      aria-label="Mobile Hauptnavigation"
      className="mobile-app-dock no-print fixed bottom-0 inset-x-0 z-40 grid grid-cols-5 overflow-hidden lg:hidden"
    >
      {MOBILE_DESTINATIONS.map((item) => {
        const active = isDestinationActive(item, location.pathname, location.search);
        const Icon = item.icon;
        return (
          <button
            key={item.key}
            type="button"
            data-testid={`mobile-dock-${item.key}`}
            aria-current={active ? "page" : undefined}
            onClick={() => {
              navigate(item.to);
              window.scrollTo({ top: 0, behavior: "auto" });
            }}
            className={`relative min-w-0 min-h-[60px] flex flex-col items-center justify-center gap-1 text-[10px] font-bold transition-colors active:scale-95 ${active ? "text-slate-950" : "text-slate-500 hover:text-slate-700"}`}
          >
            {active && <span className="absolute top-0 h-0.5 w-8 rounded-full" style={{ background: item.color }} />}
            <span
              className={`relative h-7 w-7 rounded-[9px] flex items-center justify-center text-white shadow-sm transition-all ${active ? "opacity-100" : "opacity-50 saturate-50"}`}
              style={{ background: item.color }}
            >
              <Icon className="h-4 w-4" />
              {item.key === "chat" && chatUnread > 0 && (
                <span data-testid="mobile-dock-chat-badge" className="absolute -top-1.5 -right-2 h-4 min-w-4 px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center">
                  {chatUnread > 99 ? "99+" : chatUnread}
                </span>
              )}
            </span>
            {item.label}
          </button>
        );
      })}
    </nav>
  );
}
